import React , {useContext,useEffect} from 'react'
import { MouseContext } from "../context/mouseContext" //cursor 
import AOS from 'aos'; //animation library
import "aos/dist/aos.css"; //animation library style

import Footer from './Footer'
const Form = () => {
    const { cursorChangeHandler } = useContext(MouseContext); //cursor
    //aos animation init
    useEffect(() => {
        AOS.init({
            duration : 800
        });
    }, []);
    return (
        <section id="form" className=' d-flex justify-content-center align-items-center'>
            <div className="container">
                <div className="d-flex justify-content-md-center justify-content-sm-start align-items-center">
                    <div className='d-md-block d-none footerLap'>
                        <Footer/>
                    </div>
                    <a 
                        href="mailto:info@macline.online"
                        onMouseEnter={() => cursorChangeHandler("hovered")}
                        onMouseLeave={() => cursorChangeHandler("")}
                    >
                        <div className="form-content">
                            <h1 data-aos="fade-up">Send a<br/>Request</h1>
                            <p data-aos="fade-up" >Or say hello</p>
                        </div>
                    </a>
                </div>
            </div>
            <div className='d-md-none d-block footerPhone'>
                <Footer/>
            </div>
        </section>
    )
}

export default Form